var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#BEBEBE;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 792,
    height: 612
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "303.8,360.1 301.6,360.1 290.6,429.7 314.7,429.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,519h762.8V302.8H14.2V519z M591.5,330.7h76.5v21.5h-53.8v38.9h44.5v21.5h-44.5v51.9h55.1v21.5h-77.8 V330.7H591.5z M419.7,443.1h23.7c1.3,15.1,7.4,23.8,17,23.8c10.3,0,16.7-5.9,16.7-15.4c0-14.6-11.7-24.4-24-34.7 c-14.5-12-30.9-25.7-30.9-49.9c0-24.2,14.9-38.2,40.8-38.2c20.4,0,34,14,36.5,37.2l0.1,1.6l-23.9,0.1 c-1.7-16.1-12.1-17.4-15.3-17.4c-9.3,0-14.5,6.1-14.5,16.5c0,12.4,11.2,21.8,23.1,31.9c15,12.7,31.8,27.1,31.8,50.4 c0,24.2-16,39.3-41.6,39.3c-26,0-38.5-21.4-39.5-42.5L419.7,443.1z M286.7,330.7h31.8l28.6,155.3h-24l-4.8-34.9h-31.5l-4.8,34.9 h-24L286.7,330.7z M108.5,367.9c0-28.9,20.8-39.2,40.4-39.2c18.9,0,39.1,11.1,39.1,42.1v3.7h-24.9v-4.3c0-14.8-7.3-20-14.1-20 c-11,0-15.4,5.4-15.4,18.4v79.7c0,13.2,4.5,18.4,15.4,18.4c9.7,0,14.1-5.3,14.1-16.9v-8h24.8v7.1c0,28.9-20.1,39.2-39.1,39.2 c-19.6,0-40.4-10.3-40.4-39.2v-80.9H108.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,68v216.2h762.8V68C776.9,68,14.2,68,14.2,68z M147.1,253.9c-26,0-38.5-21.4-39.5-42.5v-2.6h23.7 c1.3,15.1,7.4,23.8,17,23.8c10.3,0,16.7-5.9,16.7-15.4c0-14.6-11.7-24.4-24-34.7c-14.5-12-30.9-25.7-30.9-49.9 c0-24.2,14.9-38.2,40.8-38.2c20.4,0,34,14,36.5,37.2l0.1,1.6l-23.9,0.1c-1.7-16.1-12.1-17.4-15.3-17.4c-9.3,0-14.5,6.1-14.5,16.5 c0,12.4,11.2,21.8,23.1,31.9c15,12.7,31.8,27.1,31.8,50.4C188.8,238.8,172.8,253.9,147.1,253.9z M341.3,251.7h-24.9v-69.8h-30.8 v69.8h-24.9V96.4h24.9v64.1h30.8V96.4h24.9V251.7z M500.6,214.5c0,28.9-20.8,39.2-40.4,39.2c-19.6,0-40.4-10.3-40.4-39.2v-81.1 c0-28.9,20.8-39.2,40.4-39.2c19.6,0,40.4,10.3,40.4,39.2V214.5z M668.3,252.3h-22l-19.6-103.6l-0.1-0.3h-1.1l-18.3,104h-22 L555.5,95.8H580L596.6,196h1.1l17.6-100.2h21.5l18.2,99.9l0.1,0.3h1.1l15-100.2h24.5L668.3,252.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M460.2,115.7c-11,0-15.4,5.4-15.4,18.4v79.8c0,13.2,4.5,18.4,15.4,18.4s15.4-5.4,15.4-18.4v-79.7 C475.7,121.1,471.2,115.7,460.2,115.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcase);
export default __webpack_public_path__ + "static/media/showcase.fb5716145749f42983f714637da2797d.svg";
export { ForwardRef as ReactComponent };